/**
 * BlogListPage.js - Public blog article listing page
 * Route: /blog
 */

import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Logo from './Logo';
import { getBlogArticles } from '../services/api';
import './BlogListPage.css';

function formatDate(dateStr) {
  if (!dateStr) return '';
  return new Date(dateStr).toLocaleDateString('en-US', {
    year: 'numeric', month: 'long', day: 'numeric'
  });
}

function BlogListPage() {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    document.title = 'Blog | LeagueMaker';
    loadArticles();
  }, []);

  const loadArticles = async () => {
    try {
      const data = await getBlogArticles();
      setArticles(data);
    } catch (err) {
      setError('Failed to load articles. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="blog-list-page">
      <nav className="blog-list-nav">
        <Link to="/" className="blog-list-logo-link">
          <Logo size="1.5rem" /> LeagueMaker
        </Link>
        <Link to="/" className="blog-list-nav-link">Log In</Link>
      </nav>

      <div className="blog-list-header">
        <h1>Blog</h1>
        <p>Tips, guides, and updates for league organizers</p>
      </div>

      <div className="blog-list-content">
        {loading && <div className="blog-list-loading">Loading articles...</div>}
        {error && <div className="blog-list-error">{error}</div>}
        {!loading && !error && articles.length === 0 && (
          <div className="blog-list-empty">No articles published yet. Check back soon!</div>
        )}
        {!loading && !error && articles.length > 0 && (
          <div className="blog-list-grid">
            {articles.map(article => (
              <Link
                key={article.id}
                to={`/blog/${article.slug}`}
                className="blog-list-card"
              >
                <div className="blog-list-card-meta">
                  {formatDate(article.publishedAt)}
                  {article.author?.name && ` · ${article.author.name}`}
                </div>
                <h2>{article.title}</h2>
                {article.excerpt && (
                  <p className="blog-list-card-excerpt">{article.excerpt}</p>
                )}
                <span className="blog-list-card-cta">Read more →</span>
              </Link>
            ))}
          </div>
        )}
      </div>

      <footer className="blog-list-footer">
        <div style={{ marginBottom: '0.4rem' }}>
          <Link to="/terms">Terms</Link>
          <span className="blog-list-footer-divider">|</span>
          <Link to="/privacy">Privacy</Link>
          <span className="blog-list-footer-divider">|</span>
          <Link to="/pricing">Pricing</Link>
        </div>
        <div>© {new Date().getFullYear()} LeagueMaker</div>
      </footer>
    </div>
  );
}

export default BlogListPage;
